// extracted by mini-css-extract-plugin
export default {"green_block":"GreenBlock_green_block__N87nG"};